module.exports = {
	"textures": [
		{
			"image": "BallSim02.png",
			"format": "RGBA8888",
			"size": {
				"w": 256,
				"h": 256
			},
			"scale": 1,
			"frames": [
				{
					"filename": "106.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 179,
						"y": 181,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 1,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "115.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 123,
						"y": 157,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 17,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "125.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 156,
						"y": 171,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 33,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "98.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 209,
						"y": 141,
						"w": 14,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 49,
						"w": 14,
						"h": 14
					}
				},
				{
					"filename": "100.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 204,
						"y": 156,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 65,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "102.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 199,
						"y": 173,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 81,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "105.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 181,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 97,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "107.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 181,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 113,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "111.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 148,
						"y": 173,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 129,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "114.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 125,
						"y": 158,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 145,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "116.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 124,
						"y": 157,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 161,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "117.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 125,
						"y": 157,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 177,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "120.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 132,
						"y": 162,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 193,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "126.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 163,
						"y": 167,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 209,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "131.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 173,
						"y": 147,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 225,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "135.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 178,
						"y": 141,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 1,
						"y": 241,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "57.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 105,
						"y": 96,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 65,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "58.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 84,
						"y": 120,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 17,
						"y": 1,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "65.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 68,
						"y": 340,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 17,
						"y": 17,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "66.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 86,
						"y": 367,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 17,
						"y": 33,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "83.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 437,
						"y": 181,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 17,
						"y": 49,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "86.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 386,
						"y": 98,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 81,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "94.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 218,
						"y": 84,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 97,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "96.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 215,
						"y": 123,
						"w": 13,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 113,
						"w": 13,
						"h": 14
					}
				},
				{
					"filename": "61.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 46,
						"y": 209,
						"w": 12,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 129,
						"w": 12,
						"h": 14
					}
				},
				{
					"filename": "63.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 47,
						"y": 277,
						"w": 12,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 145,
						"w": 12,
						"h": 14
					}
				},
				{
					"filename": "82.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 445,
						"y": 214,
						"w": 12,
						"h": 14
					},
					"frame": {
						"x": 16,
						"y": 161,
						"w": 12,
						"h": 14
					}
				},
				{
					"filename": "103.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 196,
						"y": 182,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 177,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "109.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 164,
						"y": 183,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 30,
						"y": 129,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "118.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 126,
						"y": 158,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 30,
						"y": 144,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "122.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 140,
						"y": 171,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 30,
						"y": 159,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "123.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 145,
						"y": 176,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 65,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "127.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 169,
						"y": 164,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 80,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "132.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 178,
						"y": 142,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 95,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "134.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 181,
						"y": 139,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 31,
						"y": 110,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "55.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 158,
						"y": 60,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 1,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "56.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 130,
						"y": 76,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 16,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "74.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 324,
						"y": 428,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 31,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "75.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 353,
						"y": 413,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 46,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "76.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 379,
						"y": 393,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 192,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "85.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 407,
						"y": 123,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 207,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "87.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 361,
						"y": 78,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 222,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "92.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 221,
						"y": 48,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 16,
						"y": 237,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "93.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 219,
						"y": 66,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 174,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "95.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 216,
						"y": 104,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 46,
						"y": 125,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "97.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 212,
						"y": 135,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 46,
						"y": 140,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "99.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 206,
						"y": 149,
						"w": 14,
						"h": 13
					},
					"frame": {
						"x": 46,
						"y": 155,
						"w": 14,
						"h": 13
					}
				},
				{
					"filename": "101.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 201,
						"y": 165,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 61,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "104.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 191,
						"y": 182,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 76,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "108.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 169,
						"y": 182,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 91,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "110.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 157,
						"y": 179,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 106,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "112.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 140,
						"y": 168,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 1,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "113.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 132,
						"y": 163,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 16,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "119.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 129,
						"y": 159,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 31,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "121.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 136,
						"y": 167,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 46,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "124.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 151,
						"y": 176,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 189,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "128.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 171,
						"y": 159,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 204,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "129.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 171,
						"y": 155,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 219,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "130.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 172,
						"y": 151,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 32,
						"y": 234,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "133.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 137,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 189,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "136.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 145,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 48,
						"y": 170,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "137.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 178,
						"y": 142,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 204,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "139.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 192,
						"y": 132,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 219,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "161.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 365,
						"y": 274,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 47,
						"y": 234,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "67.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 108,
						"y": 391,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 185,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "68.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 133,
						"y": 411,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 200,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "77.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 402,
						"y": 370,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 215,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "78.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 420,
						"y": 343,
						"w": 13,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 230,
						"w": 13,
						"h": 13
					}
				},
				{
					"filename": "1.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 437,
						"y": 184,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 61,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "164.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 351,
						"y": 309,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 1,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "167.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 327,
						"y": 338,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 16,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "168.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 317,
						"y": 346,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 31,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "17.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 55,
						"y": 176,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 46,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "171.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 283,
						"y": 363,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 76,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "174.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 246,
						"y": 369,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 91,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "18.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 47,
						"y": 207,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 106,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "2.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 425,
						"y": 155,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 121,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "38.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 442,
						"y": 285,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 136,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "41.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 441,
						"y": 199,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 62,
						"y": 151,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "42.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 434,
						"y": 175,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 63,
						"y": 166,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "43.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 424,
						"y": 152,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 61,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "45.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 396,
						"y": 111,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 77,
						"y": 1,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "5.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 367,
						"y": 84,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 77,
						"y": 16,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "59.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 67,
						"y": 148,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 77,
						"y": 31,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "60.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 54,
						"y": 178,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 77,
						"y": 46,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "62.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 44,
						"y": 243,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 76,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "64.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 55,
						"y": 310,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 91,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "79.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 434,
						"y": 314,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 106,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "80.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 443,
						"y": 282,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 121,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "84.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 425,
						"y": 151,
						"w": 12,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 136,
						"w": 12,
						"h": 13
					}
				},
				{
					"filename": "19.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 44,
						"y": 239,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 76,
						"y": 151,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "20.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 46,
						"y": 272,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 77,
						"y": 166,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "81.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 447,
						"y": 249,
						"w": 11,
						"h": 13
					},
					"frame": {
						"x": 89,
						"y": 151,
						"w": 11,
						"h": 13
					}
				},
				{
					"filename": "53.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 223,
						"y": 43,
						"w": 14,
						"h": 12
					},
					"frame": {
						"x": 77,
						"y": 181,
						"w": 14,
						"h": 12
					}
				},
				{
					"filename": "69.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 161,
						"y": 427,
						"w": 14,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 166,
						"w": 14,
						"h": 12
					}
				},
				{
					"filename": "70.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 192,
						"y": 438,
						"w": 14,
						"h": 12
					},
					"frame": {
						"x": 77,
						"y": 195,
						"w": 14,
						"h": 12
					}
				},
				{
					"filename": "88.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 333,
						"y": 62,
						"w": 14,
						"h": 12
					},
					"frame": {
						"x": 77,
						"y": 209,
						"w": 14,
						"h": 12
					}
				},
				{
					"filename": "89.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 303,
						"y": 50,
						"w": 14,
						"h": 12
					},
					"frame": {
						"x": 77,
						"y": 223,
						"w": 14,
						"h": 12
					}
				},
				{
					"filename": "10.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 216,
						"y": 46,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 77,
						"y": 237,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "148.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 302,
						"y": 135,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 92,
						"y": 237,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "150.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 323,
						"y": 149,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 93,
						"y": 180,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "156.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 364,
						"y": 212,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 93,
						"y": 194,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "23.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 78,
						"y": 360,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 93,
						"y": 208,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "26.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 146,
						"y": 422,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 93,
						"y": 222,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "28.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 205,
						"y": 443,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 107,
						"y": 236,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "32.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 331,
						"y": 427,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 61,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "33.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 358,
						"y": 412,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 91,
						"y": 1,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "34.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 382,
						"y": 393,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 91,
						"y": 15,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "46.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 378,
						"y": 94,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 91,
						"y": 29,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "50.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 290,
						"y": 49,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 91,
						"y": 43,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "54.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 190,
						"y": 49,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 75,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "71.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 225,
						"y": 444,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 89,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "72.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 259,
						"y": 444,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 103,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "73.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 293,
						"y": 439,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 117,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "90.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 271,
						"y": 43,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 90,
						"y": 131,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "91.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 235,
						"y": 42,
						"w": 13,
						"h": 12
					},
					"frame": {
						"x": 102,
						"y": 145,
						"w": 13,
						"h": 12
					}
				},
				{
					"filename": "0.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 444,
						"y": 216,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 106,
						"y": 159,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "12.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 156,
						"y": 64,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 108,
						"y": 173,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "13.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 129,
						"y": 80,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 108,
						"y": 187,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "138.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 181,
						"y": 138,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 108,
						"y": 201,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "14.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 105,
						"y": 99,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 108,
						"y": 215,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "140.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 204,
						"y": 128,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "141.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 216,
						"y": 124,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 106,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "142.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 229,
						"y": 122,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 106,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "143.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 241,
						"y": 121,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 106,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "144.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 254,
						"y": 121,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 106,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "145.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 267,
						"y": 123,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "146.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 279,
						"y": 126,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 85,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "147.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 291,
						"y": 130,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 99,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "149.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 313,
						"y": 142,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 113,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "15.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 85,
						"y": 122,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 105,
						"y": 127,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "151.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 333,
						"y": 158,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 117,
						"y": 141,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "152.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 341,
						"y": 167,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 120,
						"y": 155,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "153.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 349,
						"y": 177,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 119,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "154.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 355,
						"y": 188,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 120,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "155.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 360,
						"y": 200,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 120,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "157.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 367,
						"y": 224,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 120,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "158.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 369,
						"y": 237,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 120,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "159.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 369,
						"y": 249,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 119,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "16.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 68,
						"y": 148,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 119,
						"y": 85,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "160.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 368,
						"y": 262,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 119,
						"y": 99,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "162.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 362,
						"y": 287,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 119,
						"y": 113,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "163.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 357,
						"y": 298,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 119,
						"y": 127,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "165.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 344,
						"y": 320,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 131,
						"y": 141,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "166.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 336,
						"y": 330,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 133,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "169.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 306,
						"y": 353,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 134,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "170.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 295,
						"y": 359,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 134,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "172.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 271,
						"y": 367,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 134,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "173.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 258,
						"y": 369,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 134,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "175.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 233,
						"y": 369,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 133,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "176.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 221,
						"y": 367,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 133,
						"y": 85,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "177.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 208,
						"y": 364,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 133,
						"y": 99,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "178.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 196,
						"y": 360,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 133,
						"y": 113,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "179.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 354,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 133,
						"y": 127,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "180.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 174,
						"y": 348,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 169,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "181.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 164,
						"y": 340,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 134,
						"y": 155,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "182.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 155,
						"y": 331,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 145,
						"y": 141,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "183.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 147,
						"y": 322,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 183,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "184.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 139,
						"y": 311,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 197,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "185.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 133,
						"y": 300,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 211,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "21.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 52,
						"y": 304,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 225,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "22.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 63,
						"y": 333,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 122,
						"y": 239,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "24.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 98,
						"y": 384,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 147,
						"y": 57,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "25.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 121,
						"y": 405,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 148,
						"y": 1,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "3.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 410,
						"y": 129,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 148,
						"y": 15,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "30.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 271,
						"y": 445,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 148,
						"y": 29,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "35.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 403,
						"y": 370,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 148,
						"y": 43,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "36.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 421,
						"y": 344,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 147,
						"y": 71,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "4.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 390,
						"y": 105,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 147,
						"y": 85,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "40.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 445,
						"y": 225,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 147,
						"y": 99,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "44.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 411,
						"y": 131,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 147,
						"y": 113,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "47.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 359,
						"y": 79,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 147,
						"y": 127,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "48.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 338,
						"y": 66,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 136,
						"y": 169,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "49.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 315,
						"y": 56,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 148,
						"y": 155,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "51.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 265,
						"y": 45,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 159,
						"y": 141,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "6.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 341,
						"y": 68,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 136,
						"y": 183,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "7.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 312,
						"y": 55,
						"w": 12,
						"h": 12
					},
					"frame": {
						"x": 136,
						"y": 197,
						"w": 12,
						"h": 12
					}
				},
				{
					"filename": "37.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 434,
						"y": 316,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 136,
						"y": 211,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "39.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 446,
						"y": 253,
						"w": 11,
						"h": 12
					},
					"frame": {
						"x": 136,
						"y": 225,
						"w": 11,
						"h": 12
					}
				},
				{
					"filename": "8.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 281,
						"y": 48,
						"w": 13,
						"h": 11
					},
					"frame": {
						"x": 136,
						"y": 239,
						"w": 13,
						"h": 11
					}
				},
				{
					"filename": "11.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 185,
						"y": 53,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 149,
						"y": 211,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "27.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 175,
						"y": 435,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 149,
						"y": 224,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "29.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 238,
						"y": 447,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 151,
						"y": 237,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "31.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 302,
						"y": 439,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 150,
						"y": 169,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "52.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 239,
						"y": 45,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 162,
						"y": 155,
						"w": 12,
						"h": 11
					}
				},
				{
					"filename": "9.png",
					"rotated": false,
					"trimmed": true,
					"sourceSize": {
						"w": 500,
						"h": 500
					},
					"spriteSourceSize": {
						"x": 249,
						"y": 45,
						"w": 12,
						"h": 11
					},
					"frame": {
						"x": 150,
						"y": 182,
						"w": 12,
						"h": 11
					}
				}
			]
		}
	],
	"meta": {
		"app": "https://www.codeandweb.com/texturepacker",
		"version": "3.0",
		"smartupdate": "$TexturePacker:SmartUpdate:de70889c6da46fb7f3f4f0282e57d0d0:e240007717d4420e03264a9fd117dc47:f857d9531afbc2a82f494ddcf0bc1537$"
	}
}
;